import React from 'react'
import { useTranslation } from 'lib/i18n'
import dynamic from 'next/dynamic'

import CmsPageBasic from 'components/CmsPage/CmsPageBasic'
import CtaLink from 'components/CtaLink/CtaLink'
import Link from 'components/Link/Link'

import styles from './SearchResults.module.css'

const ClearSearchButton = dynamic(() => import('./ClearSearchButton'))

type NoResultProps = {
  searchTerm: string
  filterEnabled: boolean
}

const NoResult = ({
  searchTerm = '',
  filterEnabled = false,
}: NoResultProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <>
      <div className={styles.empty} data-cy="noSearchResultsContainer">
        <p className={styles.emptyTitle}>
          {t('searchResults.empty', 'No profiles found')}
        </p>
        <p className={styles.emptyText}>
          {t(
            'searchResults.emptySuggestText2',
            "We couldn't find anything matching {{searchTerm}}. Try a broader search term or",
            { searchTerm },
          )}{' '}
          <Link href={`/suggest?searchTerm=${searchTerm}`} passHref>
            <CtaLink>
              {t('searchResults.goToSuggestion', 'suggest a profile')}
            </CtaLink>
          </Link>
        </p>

        {filterEnabled && (
          <div className={styles.clearFilterButton}>
            <ClearSearchButton clearsQuery />
          </div>
        )}

        <p className={styles.suggestedProfiles}>
          {t(
            'searchResults.suggestedProfiles',
            'Have a look at other popular profiles',
          )}
        </p>
      </div>

      <CmsPageBasic slug="search" />
    </>
  )
}

export default NoResult
